import ENV from "config";
/**
 * Checks if the application is in public view mode.
 * @returns {boolean} Returns true if the application is in public view mode, otherwise false.
 */
export default function isPublicView(): boolean {
  if (ENV.PUBLIC_VIEW === "TRUE") {
    return true;
  }
  return false;
}
